export const whiteTransparent = 'rgba(255, 255, 255, 0.75)';